import { m } from "@/paraglide/messages";
export const SOCIALS: {
	name: string;
	href: string;
	desc: string;
}[] = [
	{
		name: "X",
		href: "https://x.com/PeachLustAPP",
		desc: m.profile_contact_x(),
	},
	{
		name: "Discord",
		href: "https://discord.gg/gxT6D8ZVMj",
		desc: m.profile_contact_discord(),
	},
	{
		name: "Telegram",
		href: "https://t.me/peach_lust",
		desc: m.profile_contact_telegram(),
	},
];
